<template>
	<span>
		<icone-simples-redondo-com-label
			label-botao="P"
			:texto="message"
			cor-background="orange"
		></icone-simples-redondo-com-label>
	</span>
</template>
<script>
import IconeSimplesRedondoComLabel from '@/views/components/icones/IconeSimplesRedondoComLabel.vue'
import FormatDataFilter from '@/views/filters/format-data-filter'

export default {
	name: 'icone-ata-prorrogada',
	components: { IconeSimplesRedondoComLabel },
	props: {
		fimValidade: {
			type: String,
			required: true,
		},
	},
	computed: {
		message() {
			return `Prorrogada até ${FormatDataFilter(this.fimValidade)}`
		},
	},
}
</script>
